import { useCallback } from "react";

import { useGetUserProfile } from "@/api/queries/userProfile";
import { useFeatureFlag } from "@/components/FeatureFlagProvider";
import { type SmsConsentNudgeFlow, useSmsConsentNudgeStore } from "@/store";

export const useSmsConsentNudge = (conversationId: string | undefined) => {
  const { value: isEnabled } = useFeatureFlag("sms-consent-nudge", false);
  const { data: userProfile } = useGetUserProfile();
  const entry = useSmsConsentNudgeStore((s) =>
    conversationId ? s.byConversation[conversationId] : undefined,
  );
  const storeTriggerNudge = useSmsConsentNudgeStore((s) => s.triggerNudge);
  const dismissNudge = useSmsConsentNudgeStore((s) => s.dismissNudge);

  const smsConsent = userProfile?.consents?.sms_consent_to_treat;
  const isConsentAnswered = smsConsent === true || smsConsent === false;
  const shouldPromptSmsConsent = isEnabled && !isConsentAnswered;

  const triggerNudge = useCallback(
    (id: string, flow: SmsConsentNudgeFlow) => {
      if (isConsentAnswered) return;
      storeTriggerNudge(id, flow);
    },
    [isConsentAnswered, storeTriggerNudge],
  );

  return {
    shouldShow: shouldPromptSmsConsent && entry?.state === "pending",
    flow: entry?.flow,
    shouldPromptSmsConsent,
    triggerNudge,
    dismissNudge,
  };
};
